// src/components/ContactForm.jsx

import React, { useState } from 'react';
import '../styles/ContactForm.css';
const ContactForm = ({ apiEndpoint }) => {
  const [formData, setFormData] = useState({
    email: '',
    countryCode: '',
    phoneNumber: ''
  });
  
  const [errors, setErrors] = useState({});
  const [submitStatus, setSubmitStatus] = useState({ type: '', message: '' });

  const countryCodes = [
    { code: '+1', country: 'US/CA' },
    { code: '+44', country: 'UK' },
    { code: '+61', country: 'AU' },
    { code: '+91', country: 'IN' },
    { code: '+86', country: 'CN' },
    { code: '+49', country: 'DE' },
    { code: '+33', country: 'FR' },
    { code: '+81', country: 'JP' }
  ];

  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const validatePhoneNumber = (phone) => {
    const regex = /^\d{6,12}$/;
    return regex.test(phone.replace(/[-\s]/g, ''));
  };

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!validateEmail(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (!formData.countryCode) {
      newErrors.countryCode = 'Country code is required';
    }

    if (!formData.phoneNumber) {
      newErrors.phoneNumber = 'Phone number is required';
    } else if (!validatePhoneNumber(formData.phoneNumber)) {
      newErrors.phoneNumber = 'Please enter a valid phone number (6-12 digits)';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    try {
      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: formData.email,
          countryCode: formData.countryCode,
          phoneNumber: formData.phoneNumber,
          fullPhoneNumber: `${formData.countryCode}${formData.phoneNumber}`
        }),
      });

      if (response.ok) {
        setSubmitStatus({
          type: 'success',
          message: 'Form submitted successfully!'
        });
        setFormData({ email: '', countryCode: '', phoneNumber: '' });
      } else {
        throw new Error('Submission failed');
      }
    } catch (error) {
      setSubmitStatus({
        type: 'error',
        message: 'There was an error submitting the form. Please try again.'
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  return (
    <div className="contact-container">
      <div className="header">
        <h1>AI: The SEO Game-Changer You Can't Ignore</h1>
        <div className="benefits">
          <p>
            The SEO landscape is transforming, and AI is leading the revolution! 🚀 
            Discover how artificial intelligence is rewriting the rules of search optimization, 
            helping businesses:
          </p>
          <ul className="benefits-list">
            <li>
              <span className="check-mark">✓</span>
              <span>Boost organic rankings faster</span>
            </li>
            <li>
              <span className="check-mark">✓</span>
              <span>Create smarter content strategies</span>
            </li>
            <li>
              <span className="check-mark">✓</span>
              <span>Outperform competitors with AI-powered insights</span>
            </li>
          </ul>
          <p className="cta">
            Click to learn how AI can supercharge your SEO game! 💻🔍
          </p>
        </div>
      </div>

      <div className="contact-form">
        <h2>Contact Information</h2>
        <p>Please provide your contact details</p>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="email">
              Email <span className="required">*</span>
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="your@email.com"
              required
            />
            {errors.email && <p className="error">{errors.email}</p>}
          </div>

          <div className="form-group">
            <label>
              Phone Number <span className="required">*</span>
            </label>
            <div className="phone-input-group">
              <div className="country-code">
                <select
                  name="countryCode"
                  value={formData.countryCode}
                  onChange={handleChange}
                  required
                >
                  <option value="">Code</option>
                  {countryCodes.map(({ code, country }) => (
                    <option key={code} value={code}>
                      {code} {country}
                    </option>
                  ))}
                </select>
                {errors.countryCode && <p className="error">{errors.countryCode}</p>}
              </div>
              <div className="phone-number">
                <input
                  type="tel"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  placeholder="Phone number"
                  required
                />
                {errors.phoneNumber && <p className="error">{errors.phoneNumber}</p>}
              </div>
            </div>
          </div>

          <button type="submit">Submit</button>
        </form>

        {submitStatus.message && (
          <div className={`alert ${
            submitStatus.type === 'success' ? 'alert-success' : 'alert-error'
          }`}>
            {submitStatus.message}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactForm;